import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { SolicitudesCreditoFacturadasHeader } from "./SolicitudesCreditoFacturadasHeader";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { FiltradoOperacionesCredito } from "./FiltradoOperacionesCredito";
import { useLocation } from "react-router-dom";
import ArticleIcon from "@mui/icons-material/Article";
import Swal from "sweetalert2";
import { TablaSolicitudesGeneral } from "./TablaSolicitudesGeneral";
import { TablaSolicitudesDetalle } from "./TablaSolicitudesDetalle";

export const SolicitudCreditoFacturada = () => {
  const history = useHistory();
  const location = useLocation();
  const [ocultar, setOcultar] = useState(false);
  const [cardSelected, setCardSelected] = useState(1);
  const [cardSelectedText, setCardSelectedText] = useState();
  const [filtro, setFiltro] = useState({
    periodo: "",
    ejercicio: "",
    linea: "",
  });
  const [titulo, setTitulo] = useState({
    main: "RESULTADO DE OPERACIONES",
    show: "RESULTADO DE OPERACIONES",
    ejercicio: 0,
    periodo: 0,
  });
  const [state, setState] = useState({
    resumen: {},
    data: [],
  });
  const [cardCerrados, setCardCerrados] = useState({
    card: "",
    titulo: "",
  });
  const [dataCard, setDataCard] = useState([]);
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });
  const [tableshow, setTableShow] = useState("G");
  const onExecute = (ejercicio, periodo, linea) => {
    const Linea =
      linea !== null && linea !== "" && linea !== undefined ? linea : "TT";
    return new Promise((resolve, rejec) => {
      setLoader({ ...loader, mostrar: true });
      request
        .get(
          `SolicitudesCreditoFacturadas/SolicitudesFacturadas?ejercicio=${Number(
            ejercicio
          )}&periodo=${Number(periodo)}&linea=${Linea}`
        )
        .then((result) => {
          setLoader({ ...loader, mostrar: false });
          setState({
            resumen: result.resumen,
            data: result.sucursal,
          });
          setTableShow("G");
          setCardSelected(1);
          setTitulo({
            ...titulo,
            show: result.resumen.titulo,
            ejercicio,
            periodo,
          });
          resolve("");
          return;
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          rejec(error);
          return;
        });
    });
  };

  const onSolicitudesPendientes = () => {
    history.push({
      pathname: "/SolicitudCredito/ResultadosOperacion",
      Roperaciones: {
        titulo: "OPERACIONES PENDIENTES DE",
        ejercicio: filtro.ejercicio,
        periodo: filtro.periodo,
        linea: filtro.linea,
      },
    });
  };

  useEffect(() => {
    const filtroGuardado = localStorage.getItem("filtrocargado");
    if (filtroGuardado) {
      setFiltro(JSON.parse(filtroGuardado));
      const { ejercicio, periodo, linea } = JSON.parse(filtroGuardado);
      onExecute(ejercicio, periodo, linea);
    }

    return () => {
      localStorage.removeItem("filtrocargado");
    };
  }, []);

  useEffect(() => {
    if (location.state !== undefined && location.state !== null) {
      setOcultar(true);
      setFiltro({
        ...filtro,
        ejercicio: location.state.ejercicio,
        periodo: location.state.periodo,
      });
      onExecute(location.state.ejercicio, location.state.periodo);
    }
  }, []);

  const onGeneraExcel = () => {
    const Linea =
      filtro.linea !== null && filtro.linea !== "" && filtro.linea !== undefined
        ? filtro.linea
        : "TT";
    setLoader({ ...loader, mostrar: true });

    request
      .get(
        `OperacionesCerradasCard/GenerarExcelOperaciones?ejercicio=${Number(
          filtro.ejercicio
        )}&periodo=${Number(
          filtro.periodo
        )}&linea=${Linea}&card=${cardSelectedText}`
      )
      .then(({ documento, filename }) => {
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setLoader({ ...loader, mostrar: false });
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("RESULTADO DE OPERACIONES", JSON.stringify(error), "error");
      });
  };

  const onCargarOtros = (cardseleccionado, titulo) => {
    const Linea =
      filtro.linea !== null && filtro.linea !== "" && filtro.linea !== undefined
        ? filtro.linea
        : "TT";
    setLoader({ ...loader, mostrar: true });
    const post = {
      ejercicio: filtro.ejercicio,
      periodo: filtro.periodo,
      linea: filtro.linea,
      card: cardseleccionado,
    };
    request
      .post("OperacionesCerradasCard/Obtener", post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        if (
          result.length === undefined ||
          result.length === null ||
          result.length === 0
        ) {
          Swal.fire(titulo.show, "No se encontraron registros", "warning");
        }
        setDataCard(result);
        setCardCerrados({
          card: cardseleccionado,
          titulo,
        });
        setTableShow("O");
        return;
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        return;
      });
  };
  return (
    <PlantillaScreen
      titulo={titulo.show}
      className_main={1}
      className={"solicitud-credito-facturada"}
    >
      <div className="solicitud-credito-facturada-actions">
        <div
          className="solicitud-credito-facturada-actions-regresar"
          onClick={() => history.push("/Ventas/Main")}
        >
          <ArrowBackIcon /> Regresar
        </div>
        <FiltradoOperacionesCredito
          onExecute={onExecute}
          filtro={filtro}
          setFiltro={setFiltro}
          abrirmodal={ocultar}
        />
      </div>
      <div className="solicitud-credito-facturada-actions-excel">
        <div
          className="solicitud-credito-facturada-actions-excel-button"
          onClick={() => onGeneraExcel()}
        >
          <ArticleIcon /> Excel
        </div>
      </div>

      <LoaderScreen loader={loader} />
      {state.data !== undefined &&
      state.data !== null &&
      state.data.length > 0 ? (
        <div className="solicitud-credito-facturada-container">
          <div className="solicitud-credito-facturada-container-resumen">
            <SolicitudesCreditoFacturadasHeader
              titulo={"TOTAL"}
              cantidad={state.resumen.total_solicitudes}
              className={
                "solicitud-credito-facturada-container-resumen-item-click"
              }
              onClick={() => {
                onExecute(filtro.ejercicio, filtro.periodo, filtro.linea);
                setCardSelected(1);
                setCardSelectedText("T");
              }}
              porcentaje={"100%"}
              activo={cardSelected === 1 ? true : false}
            />
            <SolicitudesCreditoFacturadasHeader
              titulo={"Pendientes"}
              className={
                "solicitud-credito-facturada-container-resumen-item-click"
              }
              onClick={() => onSolicitudesPendientes()}
              cantidad={state.resumen.pendientes}
              porcentaje={`${FormatMoney(
                (state.resumen.pendientes / state.resumen.total_solicitudes) *
                  100,
                0
              )}%`}
            />
            <SolicitudesCreditoFacturadasHeader
              titulo={"CERRADOS"}
              cantidad={state.resumen.cerradas}
              box_bg_color="box-bg-yellow"
              porcentaje={`${FormatMoney(
                (state.resumen.cerradas / state.resumen.total_solicitudes) *
                  100,
                0
              )}%`}
              className={
                "solicitud-credito-facturada-container-resumen-item-click"
              }
              onClick={() => {
                onCargarOtros("T", "Operaciones Cerradas");
                setCardSelected(3);
                setCardSelectedText("T");
              }}
              activo={cardSelected === 3 ? true : false}
            />
            <SolicitudesCreditoFacturadasHeader
              titulo={"JDF"}
              cantidad={state.resumen.jdf}
              porcentaje={`${FormatMoney(
                (state.resumen.jdf / state.resumen.cerradas) * 100,
                1
              )}%`}
              className={
                "solicitud-credito-facturada-container-resumen-item-click"
              }
              onClick={() => {
                onCargarOtros("J", "Operaciones por John Deere Financial");
                setCardSelected(4);
                setCardSelectedText("J");
              }}
              activo={cardSelected === 4 ? true : false}
            />
            <SolicitudesCreditoFacturadasHeader
              titulo={"PRESTAMOS"}
              cantidad={state.resumen.prestamos_clientes}
              porcentaje={`${FormatMoney(
                state.resumen.prestamos_clientes === 0
                  ? 0
                  : (state.resumen.prestamos_clientes /
                      state.resumen.solicitudes_jdf) *
                      100
              ,1)} %`}
              // porcentaje={`${FormatMoney(
              //   (state.resumen.jdf / state.resumen.cerradas) * 100,
              //   1
              // )}%`}
              className={
                "solicitud-credito-facturada-container-resumen-item-click"
              }
              onClick={() => {
                onCargarOtros("P", "Operaciones de Prestamos");
                setCardSelected(5);
                setCardSelectedText("P");
              }}
              activo={cardSelected === 5 ? true : false}
            />
            <SolicitudesCreditoFacturadasHeader
              titulo={"Mhusa"}
              cantidad={state.resumen.mhusa}
              porcentaje={`${FormatMoney(
                (state.resumen.mhusa / state.resumen.cerradas) * 100,
                1
              )}%`}
              className={
                "solicitud-credito-facturada-container-resumen-item-click"
              }
              onClick={() => {
                onCargarOtros("O", "Operaciones Mhusa");
                setCardSelected(6);
                setCardSelectedText("O");
              }}
              activo={cardSelected === 6 ? true : false}
            />
            <SolicitudesCreditoFacturadasHeader
              titulo={"Contado"}
              cantidad={state.resumen.contado}
              // porcentaje={"100 %"}
              porcentaje={`${FormatMoney(
                (state.resumen.contado / state.resumen.cerradas) * 100,
                1
              )}%`}
              className={
                "solicitud-credito-facturada-container-resumen-item-click"
              }
              onClick={() => {
                onCargarOtros("C", "Operaciones de Contado");
                setCardSelected(7);
                setCardSelectedText("C");
              }}
              activo={cardSelected === 7 ? true : false}
            />
          </div>
          <div className="solicitud-credito-facturada-container-table">
            {tableshow === "G" ? (
              <TablaSolicitudesGeneral
                data={state.data}
                filtro={filtro}
                loader={loader}
                setLoader={setLoader}
                titulo={titulo}
              />
            ) : (
              <TablaSolicitudesDetalle
                data={dataCard}
                filtro={filtro}
                loader={loader}
                setLoader={setLoader}
                titulo={titulo}
                cardCerrados={cardCerrados}
              />
            )}
          </div>
        </div>
      ) : (
        <></>
      )}
    </PlantillaScreen>
  );
};
